import LegalPage, { type LegalSection } from "./LegalPage";

const SECTIONS: LegalSection[] = [
  {
    id: "who-we-are",
    heading: "Who we are",
    summary: "The company behind Beatspot and how to reach us.",
    points: [
      "Legal entity name, company registration number and registered address.",
      "Which service these terms cover: the Beatspot app, the web client and the venue profiles.",
      "How to contact us about the terms themselves.",
    ],
  },
  {
    id: "your-account",
    heading: "Your account",
    summary: "What is required to have an account, and what you are responsible for.",
    points: [
      "You must be at least 18 years old.",
      "One account per person, with accurate details.",
      "You are responsible for keeping your password to yourself.",
      "You can close your account at any time from Settings.",
    ],
  },
  {
    id: "acceptable-use",
    heading: "Acceptable use",
    summary: "What you may and may not do with Beatspot.",
    points: [
      "No harassment, impersonation or tracking of other people.",
      "No using check-ins or On my way to follow someone who has not chosen to share with you.",
      "No scraping, automated access or attempts to bypass the rate limits.",
      "No uploading content you do not have the right to share.",
    ],
  },
  {
    id: "location-sharing",
    heading: "Check-ins and location",
    summary: "The rules around the feature that makes Beatspot what it is.",
    points: [
      "Check-ins are always explicit. Beatspot does not track you in the background.",
      "A check-in expires by itself and can be ended or hidden immediately.",
      "You choose who each check-in is visible to.",
      "Live routes and exact GPS coordinates are never shared.",
    ],
  },
  {
    id: "venues",
    heading: "Venues and sensors",
    summary: "What venues get, and what the sensors do and do not record.",
    points: [
      "What a paying venue receives: live profile, exposure and basic statistics.",
      "What the sensors measure, and that they never store audio, MAC addresses or packet contents.",
      "How a venue can ask for its profile to be corrected or removed.",
    ],
  },
  {
    id: "content",
    heading: "Content and rights",
    summary: "Who owns what.",
    points: [
      "You keep the rights to what you post.",
      "The licence you give us to show your content inside Beatspot.",
      "Music metadata comes from third parties under their own terms.",
      "How to report content that infringes your rights.",
    ],
  },
  {
    id: "availability",
    heading: "Availability and changes",
    summary: "What we promise about the service, and what we do not.",
    points: [
      "Beatspot is provided as-is during the pilot phase.",
      "We may change or discontinue features, with notice where it matters.",
      "How we notify you when these terms change, and what happens to accounts that do not accept the new version.",
    ],
  },
  {
    id: "termination",
    heading: "Suspension and termination",
    summary: "When we can close an account, and what happens then.",
    points: [
      "Grounds for suspension: harassment, safety risks, repeated abuse of the rules above.",
      "What happens to your data when an account is closed, by you or by us.",
      "How to appeal a suspension.",
    ],
  },
  {
    id: "liability",
    heading: "Liability and governing law",
    summary: "The legal boilerplate, kept as short as it can be.",
    points: [
      "Limitation of liability.",
      "Governing law and venue for disputes.",
      "Your statutory consumer rights are not affected.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      intro="The agreement between you and Beatspot when you use the app."
      sections={SECTIONS}
      versionKey="terms"
    />
  );
}
